import BarcodeScanner from 'react-qr-barcode-scanner';
import './Camera.scss';
import { useEffect, useState } from 'react';
import { Popover } from '@mui/material';
export const Camera = ({ open, onClose, onScannerChange }) => {
    const [data, setData] = useState("--");
    const [realData, setRealData] = useState("");
    const [torch, setTorch] = useState(false);
    const [errCount, setErrCount] = useState(0);
    const [scanList, setScanList] = useState([]);
    const [afterScanAdded, setAfterScanAdded] = useState(false);
    // Scan List Menu
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => { setAnchorEl(event.currentTarget); };
    const handleClose = () => { setAnchorEl(null); };
    const scanListOpen = Boolean(anchorEl);
    const id = scanListOpen ? 'simple-popover' : undefined;
    // 

    const switchTorch = () => setTorch(prev => !prev)
    const removeElementAt = (idx) => {setScanList(prev => prev.filter((_, j) => !(j === idx)));}
    const addElement = (element) =>  {
        setScanList(prev => [...prev, element]);
        setData("--");
        setRealData("");
        setAfterScanAdded(true);
    }

    useEffect(() => {
        if (errCount > 3) {
            setErrCount(0);
            setData("--");
            setRealData("");
        }
    }, [errCount]);

    useEffect(() => {
        if (afterScanAdded) {
            const timeoutId = setTimeout(() => {
                setAfterScanAdded(false);
            }, 1000);

            return () => {
                clearTimeout(timeoutId);
            }
        }
    }, [afterScanAdded])

    const sendDataAndClose =  () => {
        onScannerChange(scanList);
        setData("");
        setRealData("");
        setErrCount(0);
        setAfterScanAdded(false);
        setScanList([]);
        setTorch(false);
        onClose();
    }


    return (open && <div className="camera-component">
        <div className='camera-container'>

            <BarcodeScanner
                // height={window.innerHeight}
                torch={torch}
                onUpdate={(err, result) => {
                    if (result) {
                        if (!afterScanAdded) {
                            setErrCount(0);
                            setData(result.getText());
                            setRealData(result.getText());
                        }
                    }

                    else {
                        setErrCount(prev => prev + 1);
                    }
                }}
            />
        </div>

        <div className='qr-region'>


        </div>
        {Boolean(data) && <div className='result'>
            <span>

                {data}
            </span>
            {Boolean(realData) && <i className='icon-add-aircraft' onClick={()=>addElement(data)}></i>}
        </div>}
        <div className='closebtn' onClick={sendDataAndClose}>
            <i className='icon-light-cross'></i>
        </div>
        <div className='camera-actions'>

            <i className='icon-new-apu' onClick={switchTorch}></i>
            <div className='morebtn' onClick={handleClick}>

                <i className='icon-more-horizontal'></i>
                {scanList.length > 0 && <b>
                    {scanList.length}
                </b>}

            </div>



        </div>
        <Popover
            id={id}
            open={scanListOpen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            slotProps={{
                paper: {
                    style: {
                        backgroundColor: "#AAA9",
                        borderRadius: "0.3rem",
                        boxShadow: "var(--pop-over-shadow)",
                    },
                },
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
        >
            <div className='camera-component-scanElements'>
                {
                    scanList?.length > 0 ? <>
                        {/* <b>Scanned</b> */}
                        {
                            scanList.map((n, j) => <div className='scan-element' key={`${n}-${j}`}>
                                <span>{n}</span>
                                <i className='icon-delete-new' onClick={() => removeElementAt(j)}></i>
                            </div>)
                        }
                    </> : <div className='placeholder-component small transparent'>
                        <i>No elements scanned yet</i>
                    </div>
                }

            </div>
        </Popover>
    </div>)
}